module.exports = __webpack_public_path__ + "img/5.d9a48f4a.png";